import type { NoticeType } from "@/types";

export function inferNoticeType(text: string): NoticeType {
  const normalized = text.toLowerCase();
  if (
    normalized.includes("не ") ||
    normalized.includes("ошибка") ||
    normalized.includes("invalid") ||
    normalized.includes("expired") ||
    normalized.includes("http ") ||
    normalized.includes("failed") ||
    normalized.includes("упал")
  ) {
    return "error";
  }
  return "success";
}
